
import { ExtractedData } from "../types";
import { getAuthToken } from "./firebaseService";

const sanitizeData = (obj: any): any => {
  if (Array.isArray(obj)) return obj.map(sanitizeData);
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k, sanitizeData(v)])
    );
  }
  if (obj === 'null' || obj === null || obj === undefined) return '';
  return obj;
};

export const extractDataFromPdfs = async (base64Pdfs: string[]): Promise<ExtractedData> => {
  try {
    const token = await getAuthToken();
    const response = await fetch("/api/extract", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ base64Pdfs }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to process documents.");
    }

    const parsed = await response.json();
    return sanitizeData(parsed) as ExtractedData;
  } catch (error) {
    console.error("Extraction Service Error:", error);
    throw error;
  }
};
